import { annualBenefitPlanningApi } from '../../../shared/infra/api/annual-benefit-planning.api'

import type { PolicyCostSummaryDto } from './policy-total-cost.dto'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function parseCostSummaryPayload(
  response: unknown
): PolicyCostSummaryDto | null {
  if (!isRecord(response) || response.status !== 'ok') {
    return null
  }
  const payload = response.data
  if (!isRecord(payload)) {
    return null
  }
  return payload as PolicyCostSummaryDto
}

export async function fetchPolicyCostSummary(
  clientPublicKey: string
): Promise<PolicyCostSummaryDto> {
  const { data } = await annualBenefitPlanningApi.get<unknown>(
    `clients/${encodeURIComponent(clientPublicKey)}/employees/cost-summary`
  )
  const parsed = parseCostSummaryPayload(data)
  if (parsed === null) {
    throw new Error('Invalid employee cost summary response')
  }
  return parsed
}
